export default __webpack_public_path__ + "static/Lilly-e75b7dd332e6f1efc864244046300218.jpg";